'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fileSaver = require('file-saver');

var _fileSaver2 = _interopRequireDefault(_fileSaver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IngredientRiskService = function () {
  function IngredientRiskService($http) {
    'ngInject';

    _classCallCheck(this, IngredientRiskService);

    Object.assign(this, {
      $http: $http
    });
  }

  _createClass(IngredientRiskService, [{
    key: 'getReport',
    value: function getReport(systemIngredientId) {
      return this.$http.get('/api/report/ingredient_risk/' + systemIngredientId, { responseType: 'blob' }).then(function (r) {
        if (r && r.headers('File-Name')) {
          _fileSaver2.default.saveAs(r.data, r.headers('File-Name'));
        }
      });
    }
  }]);

  return IngredientRiskService;
}();

exports.default = IngredientRiskService;


// WEBPACK FOOTER //
// ./components/app/reports/ingredient-risk/ingredient-risk.service.js